module.exports = __webpack_public_path__ + "img/Flag_of_Latvia.a6c89e39.svg";